import React from 'react';
import { FormHelperText, Stack, TextField, useTheme } from '@mui/material';
import { minimalInputTheme } from '@/app/theme';

export const NameInput = ({ value, onChange, onBlur, error, maxLength, disabled }) => {
	const theme = useTheme();

	const inputProps = theme?.typography?.deal_header ?? {};

	return (
		<Stack direction='column' width='100%'>
			<TextField
				variant='standard'
				value={value}
				disabled={disabled}
				onChange={(e) => onChange(e.target.value)}
				onBlur={(e) => onBlur(e.target.value)}
				fullWidth
				error={Boolean(error)}
				sx={{
					...minimalInputTheme,
					...inputProps,
					'& .MuiInputBase-input': {
						...inputProps,
					},
					'& .Mui-error': {
						marginLeft: 0,
					},
				}}
				slotProps={{
					input: {
						sx: {
							...inputProps,
							backgroundColor: 'transparent',
						},
					},
				}}
			/>
			<Stack direction='row' justifyContent='space-between'>
				<FormHelperText error={Boolean(error)}>{Boolean(error) && error}</FormHelperText>
				<FormHelperText
					error={Boolean(error) || value.length > maxLength}
					sx={{
						...(value.length >= maxLength && {
							fontWeight: 'bold',
						}),
						mr: '14px',
					}}
				>
					<span>{value.length}</span>
					{`/${maxLength}`}
				</FormHelperText>
			</Stack>
		</Stack>
	);
};
